<template>
  <div id="event-view">
    <modal
      v-if="statisticsEnabled"
      :show="showModal"
      @modalclosed="handleModalClose"
      position="statistics-modal">
      <div slot="header">{{ getTranslation('sportsbook.statistics') }}</div>
      <iframe
        slot="body"
        @load="showLoader = false"
        v-if="showModal"
        :src="statsLink"/>
    </modal>
    <header-menu
      :show-hours="false"
      :regenerate-links="regenerateLinks"/>
    <div
      class="event-view"
      v-if="match">
      <side-matches />
      <div class="single-match">
        <div
          class="match-info"
          :class="['sport-' + (sport? sport.providerId: 0)]">
          <div
            class="go-back"
            v-go-back>
            <i class="n-i n-i-arrow-left-a"/>
            <div>{{ getTranslation('actions.back') }}</div>
          </div>
          <div class="match-details">
            <div class="match-tournament-name">{{ match.tournamentName }}</div>
            <div class="match-time">
              {{ match.timestampUTC | time('ddd HH:mm DD.MM.YYYY') }}
            </div>
            <div class="match-name">{{ match.name }}</div>
          </div>
          <div
            v-if="statisticsEnabled"
            @click="handleModalOpen"
            class="stats-icon">
            <i class="n-i n-i-stats"/>
          </div>
        </div>
        <div
          class="bet-groups"
          v-if="betGroups.length"
          :class="{ empty: betGroups.length === 0 }">
          <div
            class="bet-group-wrapper"
            @click="toggleAllBetGroups()"
          >
            <div
              class="bet-group"
              :class="{ active: allBetGroupsSelected }">
              <span class="bet-group-name">{{ getTranslation('main.all') }}</span>
              <span class="bet-group-icon">
                <i
                  class="n-i "
                  :class="{
                    'n-i-circle': !allBetGroupsSelected,
                    'n-i-check-a': allBetGroupsSelected,
                  }"
                />
              </span>
            </div>
          </div>
          <div
            v-for="item in betGroups"
            :key="item.id"
            class="bet-group-wrapper"
            @click="toggleBetGroup(item)"
          >
            <div
              class="bet-group"
              :class="{ active: checkGroup(item.id) }">
              <span class="bet-group-name">{{ item.name }}</span>
              <span class="bet-group-icon">
                <i
                  class="n-i "
                  :class="{
                    'n-i-circle': !checkGroup(item.id),
                    'n-i-check-a': checkGroup(item.id),
                  }"
                />
              </span>
            </div>
          </div>
        </div>
        <scroller>
          <div
            class="bets-wrapper"
            :class="{
              disabled:
                (sport && !sport.active)
                || (tournament && !tournament.active)
                || (category && !category.active)
                || !match.active
            }"
            v-max-height="{
            el: ['.bet-groups', '.match-info', '.header-menu', '.footer'], offset: 45 }">
            <div
              class="bet"
              :class="{ disabled: !bet.active }"
              v-for="bet in bets"
              :key="bet.idMatchBet">
              <div class="bet-name">
                {{ bet.name }}
                <span v-if="bet.specialValue !== '*' && !bet.grouping">
                  ({{ bet.specialValue }})
                </span>
              </div>
              <div class="outcomes">
                <div v-if="bet.type === 'REGULAR'">
                  <div
                    class="outcome-wrapper"
                    :class="[ 'outcome-wrapper-' + (bet.grouped ? 2 : bet.outcomes.length) ]"
                    v-for="outcome in bet.outcomes"
                    :key="outcome.idMatchBetOutcome"
                    @click="addToBetslip(bet, outcome)">
                    <div
                      class="outcome"
                      :class="{ active: addedToBetslip(outcome) }">
                      <div class="outcome-name">
                        {{ outcome.shortName || outcome.name }}
                      </div>
                      <div
                        v-if="outcome.display"
                        class="odd-value">
                        {{ outcome.display[oddType] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="player-props">
                    <div
                      class="player-prop"
                      v-for="(group, index) in bet.outcomes"
                      :key="index"
                    >
                      <div class="players-prop-title">
                        {{ (group[0] || {}).shortName || (group[0] || {}).name }}
                      </div>
                      <div class="outcomes">
                        <div
                          v-for="(outcome, key) in group"
                          class="outcome-wrapper outcome-wrapper-2"
                          :key="key">
                          <div
                            class="outcome"
                            v-if="outcome"
                            :class="{ active: addedToBetslip(outcome) }"
                            @click="addToBetslip(bet, outcome)">
                            <div class="outcome-name">
                              {{ outcome.specialValue }}
                            </div>
                            <div
                              v-if="outcome.display"
                              class="odd-value">
                              {{ outcome.display[oddType] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </scroller>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMenu from '../../shared/header-menu/HeaderMenu.vue';
import SideMatches from './SideMatches.vue';
import Modal from '../../shared/modal/Modal.vue';
import gateway from '../../../services/gravityGateway';

export default {
  name: 'EventView',
  data() {
    return {
      selectedBetGroups: [],
      match: null,
      isTopOfferMatch: false,
      regenerateLinks: false,
      showLoader: false,
    };
  },
  computed: {
    statsLink() {
      const { statistics } = this.appSettings;
      return `${statistics.link}${statistics.clientId}/${this.company.locale}/match/${this.activeMatch.id}`;
    },
    showModal() {
      return this.$store.getters.getStatsModalState;
    },
    company() {
      return this.$store.getters.getCompany;
    },
    appSettings() {
      return this.$store.getters.getCompanyConfig;
    },
    statisticsEnabled() {
      return this.appSettings.statistics.enabled;
    },
    oddType() {
      return this.$store.getters.getActiveOddType;
    },
    betGroups() {
      return this.$store.getters.getBetGroupsForActiveMatch;
    },
    metaLoaded() {
      return this.$store.getters.getMetaLoaded;
    },
    dateFrom() {
      return this.match.timestampUTC;
    },
    tournamentId() {
      return this.match.idTournament;
    },
    activeMatch() {
      return this.$store.getters.getActiveMatch;
    },
    sport() {
      if (this.match) {
        return this.$store.getters.getSportById(this.match.idSport);
      }
      return null;
    },
    bets() {
      const bets = [];
      if (this.match && this.selectedBetGroups.length) {
        this.selectedBetGroups.forEach((group) => {
          this.match.bets.forEach((bet) => {
            if (group.bets.indexOf(bet.id) !== -1) {
              // Prevent adding duplicate bets to array
              const foundBetInBets = _.findIndex(bets, { idMatchBet: bet.idMatchBet });
              if (foundBetInBets === -1) {
                bets.push(bet);
              }
            }
          });
        });
        return _.sortBy(bets, ['position']);
      }
      return this.match.bets || [];
    },
    betslipBets() {
      return this.$store.getters.getBetslipBets;
    },
    tournament() {
      if (this.match) {
        return this.$store.getters.getTournamentById(this.match.idTournament);
      }
      return null;
    },
    category() {
      if (this.match) {
        return this.$store.getters.getCategoryById(this.match.idCategory);
      }
      return null;
    },
    allBetGroupsSelected() {
      return this.selectedBetGroups.length === this.betGroups.length;
    },
  },
  mounted() {
    this.isTopOfferMatch = this.$route.params.topOffer;
    this.fetchMatch(this.$route.params.id);
    this.storeMatch();

    const sportWatcher = this.$watch('sport', (sport) => {
      if (sport) {
        this.$store.dispatch('toggleSport', { id: sport.id });
      }

      // Stop listener
      sportWatcher();
    });

    const tournamentWatcher = this.$watch('tournament', (tournament) => {
      if (tournament) {
        this.$store.dispatch('toggleTournament', { id: tournament.id });
      }

      // Stop listener
      tournamentWatcher();
    });
  },
  destroyed() {
    this.$store.dispatch('cleanActiveMatch');
  },
  methods: {
    fetchMatch(id) {
      this.regenerateLinks = false;
      this.$store.dispatch('fetchMatch', {
        params: {
          id_match: id,
        },
      });
      this.scrollTop();
    },
    storeMatch() {
      const match = this.$store.getters.getActiveMatch;

      if (match && match.bets && this.metaLoaded) {
        // Map match bets with meta bets
        match.bets = _.map(match.bets, (b) => {
          const bet = b;
          const metaBet = this.getBetById(bet.id);
          bet.type = metaBet.type;
          bet.metaBet = metaBet;
          bet.outcomes = _.map(bet.outcomes, (o) => {
            const outcome = o;
            if (!outcome.name) {
              const metaOutcome = _.find(metaBet.outcomes, { id: outcome.id });
              outcome.name = metaOutcome.name;
              outcome.shortName = metaOutcome.shortName;
            }
            return outcome;
          });

          if (bet.type === 'PLAYER_PROPS_AT_LEAST') {
            let outcomes = _.groupBy(bet.outcomes, 'providerId');

            outcomes = _.map(outcomes, (group) => {
              _.each(group, (outcome) => {
                const specialValue = outcome.idMatchBetOutcome.split('/');
                _.assign(outcome, {
                  specialValue: specialValue[specialValue.length - 2],
                });
              });
              return group;
            });

            _.assign(bet, {
              outcomes,
            });
          }
          return bet;
        });

        this.regenerateLinks = true;
      }
      this.match = match;
    },
    getBetById(idBet) {
      return this.$store.getters.getBetById(idBet);
    },
    toggleBetGroup(group) {
      const foundIndex = _.findIndex(this.selectedBetGroups, item => item.id === group.id);

      if (foundIndex < 0) {
        this.selectedBetGroups.push(group);
      } else {
        this.selectedBetGroups.splice(foundIndex, 1);
      }
    },
    toggleAllBetGroups() {
      // All bet groups are selected or none of them
      if (this.allBetGroupsSelected || _.isEmpty(this.selectedBetGroups)) {
        _.each(this.betGroups, this.toggleBetGroup);
      } else {
        this.selectedBetGroups = [];
      }
    },
    checkGroup(id) {
      return (_.findIndex(this.selectedBetGroups, item => item.id === id)) !== -1;
    },
    addToBetslip(bet, outcome) {
      const parsedBet = {
        key: outcome.idMatchBetOutcome,
        keyBet: bet.id,
        keyOucome: outcome.idMatchBetOutcome,
        matchDisplayId: this.match.displayId,
        matchDateTimeUTC: this.match.timestampUTC,
        idMatchBet: bet.idMatchBet,
        matchId: this.match.id,
        title: this.match.name,
        subtitle: bet.name,
        outcome: outcome.name,
        oddValue: outcome.value,
        oddDisplay: outcome.display,
        specialValue: bet.specialValue,
        banker: false,
        change: null,
      };

      if (bet.type === 'PLAYER_PROPS_AT_LEAST') {
        parsedBet.outcome = `${parsedBet.outcome} (${outcome.specialValue})`;
      }

      this.$store.dispatch('addBetToBetslip', parsedBet);
    },
    addedToBetslip(outcome = {}) {
      return _.findIndex(this.betslipBets, { key: outcome.idMatchBetOutcome }) !== -1;
    },
    scrollTop() {
      const el = document.querySelector('.bets-wrapper');
      if (el) el.scrollTop = 0;
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    handleModalClose() {
      this.$store.dispatch('closeStatsModal');
      this.showLoader = false;
    },
    handleModalOpen() {
      this.$store.dispatch('openStatsModal');
      this.showLoader = !this.showLoader;
    },
  },
  components: {
    HeaderMenu,
    SideMatches,
    Modal,
  },
  beforeRouteUpdate(from, to, next) {
    this.fetchMatch(from.params.id);
    next();
  },
  watch: {
    activeMatch(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.storeMatch();
        this.selectedBetGroups = [];
      }
    },
    showLoader(newValue) {
      gateway.sendMessage('Widget.Loading', {
        isLoading: newValue,
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../../scss/default/modules/event-view';
</style>
